function StartFilter() {
  return filter;
  
  /**
  * Start at a specific index
  *
  * @param {Array} values
  * @param {Number} start
  * @return {Array} finalNumber
  */
  function filter(values, start) {

    if (!values || !values.length || !start) { return values }
  
    return values.filter( (listItem, idx) => idx >= start);

  }
}

export default StartFilter;
